module.exports = __webpack_public_path__ + "static/media/dinosaur(4).27a2ea72.PNG";